import http from "../httpService";
//const apiUrl = process.env.REACT_APP_API_URL;
//const apiUrl = "http://localhost:61682//api";
const apiUrl = http.getApiURL();

export function getNextCode(menuItemCode, trxDate, invTrxTypeID, storeID) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/INV_Trx/GetNextCode?TrxDate=${trxDate}&InvTrxTypeID=${invTrxTypeID}&StoreID=${storeID}`;

  return http.get(url, config);
}

export function getItemDetails(menuItemCode, itemID) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/INV_Trx/GetItemDetails?ItemID=${itemID}`;

  return http.get(url, config);
}


export function sendToZatca(menuItemCode, id) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  return http.get(`${apiUrl}/INV_Trx/SendToZatca?Id=${id}`, config);
}